"use client";
import { j as x } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as O } from "./tv.config-BuYIgndg.mjs";
import * as s from "react";
import { u as S } from "./useEventCallback-CjuAhyNz.mjs";
import { u as H } from "./useControlled-B2rPEZCb.mjs";
import { u as _ } from "./useRenderElement-B8V3_e8R.mjs";
import { C as z } from "./CompositeRoot-DqjHHBWD.mjs";
import { T as B } from "./ToggleGroupContext-DBIpDx7F.mjs";
const G = /* @__PURE__ */ s.createContext(void 0);
process.env.NODE_ENV !== "production" && (G.displayName = "ToolbarRootContext");
function $(e) {
  return s.useContext(G);
}
let q = /* @__PURE__ */ function(e) {
  return e.disabled = "data-disabled", e.orientation = "data-orientation", e.multiple = "data-multiple", e;
}({});
const E = {
  multiple(e) {
    return e ? {
      [q.multiple]: ""
    } : null;
  }
}, R = /* @__PURE__ */ s.forwardRef(function(r, t) {
  const {
    defaultValue: l,
    disabled: p = !1,
    loop: d = !0,
    onValueChange: c,
    orientation: n = "horizontal",
    toggleMultiple: m = !1,
    value: f,
    className: T,
    render: V,
    ...v
  } = r, a = $(), M = s.useMemo(() => {
    if (f === void 0)
      return l ?? [];
  }, [f, l]), u = ((a == null ? void 0 : a.disabled) ?? !1) || p, [i, j] = H({
    controlled: f,
    default: M,
    name: "ToggleGroup",
    state: "value"
  }), N = S((g, y, k) => {
    let o;
    m ? (o = i.slice(), y ? o.push(g) : o.splice(i.indexOf(g), 1)) : o = y ? [g] : [], Array.isArray(o) && (j(o), c == null || c(o, k));
  }), b = s.useMemo(() => ({
    disabled: u,
    multiple: m,
    orientation: n
  }), [u, n, m]), P = s.useMemo(() => ({
    disabled: u,
    orientation: n,
    setGroupValue: N,
    value: i
  }), [u, n, N, i]), C = {
    role: "group"
  }, h = _("div", r, {
    enabled: !!a,
    state: b,
    ref: t,
    props: [C, v],
    customStyleHookMapping: E
  });
  return /* @__PURE__ */ x.jsx(B.Provider, {
    value: P,
    children: a ? h : /* @__PURE__ */ x.jsx(z, {
      render: V,
      className: T,
      state: b,
      refs: [t],
      props: [C, v],
      customStyleHookMapping: E,
      loop: d,
      stopEventPropagation: !0
    })
  });
});
process.env.NODE_ENV !== "production" && (R.displayName = "ToggleGroup");
const w = O({
  slots: {
    root: [
      "flex",
      "gap-px",
      "rounded-md",
      "border",
      "border-gray-200",
      "bg-gray-50",
      "p-0.5",
      "w-auto"
    ]
  }
}), { root: A } = w(), U = (e) => {
  const { children: r, className: t, render: l, ...p } = e, d = l ? t : A({
    className: typeof t == "string" ? t : ""
  });
  return /* @__PURE__ */ x.jsx(R, { ...p, render: l, className: d, children: r });
};
export {
  U as default
};
